document
  .getElementById("spost-code-modal")
  .addEventListener("keydown", function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      document.getElementById("submit-delivery-postode").click();
    }
  });

const cartTimer = document.querySelector(".delivery-countdown");
// Shipping error messages
const noExpressDeliveryError =
  '<b>Unfortunately Express Delivery isn\'t available in your area.</b> Please select "Delivery" to check if scheduled deliveries are available in your area.';
const noDeliveryError =
  '<b>Unfortunately we do not deliver to your area.</b> To register your interest please <b><a href="https://harrisfarmsupport.zendesk.com/hc/en-us/categories/200270127-Online" target="_new">contact us</a></b>.';

$(document).ready(function () {
  var deliveryVariant;

  $("#delivery-type-select-btns button").click(function () {
    if (!$("#delivery-error-modal").hasClass("reservation-expired")) {
      $("#delivery-error-modal").hide();
    }

    $(".delivery-express-info").hide();

    if ($.cookie("delivery_preorder")) {
      $("#preorder-token").attr("checked", true);
      $("#delivery-preorder-token-input")
        .val($.cookie("delivery_preorder"))
        .change();
      $("#delivery-preorder-token-input-box").show();
    } else {
      $("#preorder-token").attr("checked", false);
      $("#delivery-preorder-token-input").val("").change();
    }

    $("#delivery-preorder-invalid").hide();
    $("#delivery-error-modal").hide();
  });

  $("#delivery-type-delivery").click(function () {
    let postcode = $("#spost-code-modal").val();

    $("#spost-code-modal").focus();
    $("#delivery-type-submit").text("Reserve Delivery");
    $("#delivery-type-reserve, #cc-store-row").hide();
    $("#delivery-type-select-btns button").removeClass(
      "delivery-type-select-btns-selected"
    );
    $(this).addClass("delivery-type-select-btns-selected");

    //$("#delivery-preorder-token").css("display", "inline-flex");

    loadDeliverySlots(postcode);
  });

  document
    .querySelectorAll(
      ".postcode-open, .delivery-details, .res-delivery-time, #seafood-change-date, #mealkit-change-date, #loosesalad-change-date, #shortdate-change-date, #instorebakery-change-date, #wholesale-change-date, #noliquorgf-change-date, #xmastree-change-date, #xmastree-non-ct-change-date, #voomcart-change-date, #voomcart-non-vc-change-date"
    )
    .forEach(function (element) {
      element.addEventListener("click", function (event) {
        theme.promptForDeliveryType();
        event.preventDefault();
      });
    });

  //delivery-edit-btn

  $("#delivery-type-click-collect").click(function () {
    loadClickCollectStores();
    $("#delivery-type-reserve").show();
    $("#cc-store-row").show();
    $("#cc-store").val("");
    $("#delivery-type-submit").text("Reserve Collection");
    $(
      "#delivery-postcode-modal, #delivery-suburb-modal, #delivery-day-modal, #delivery-type-modal, #clickcollect-info-modal, #delivery-time-modal"
    ).hide();
    $("#delivery-type-select-btns button").removeClass(
      "delivery-type-select-btns-selected"
    );
    $(this).addClass("delivery-type-select-btns-selected");

    $("#delivery-preorder-token, #delivery-preorder-token-input-box").hide();
    $.removeCookie("delivery_preorder", { path: "/" });
  });

  $("#delivery-type-express").click(function () {
    let postcode = $("#spost-code-modal").val();

    $("#spost-code-modal").focus();
    $("#delivery-type-reserve, #cc-store-row").hide();
    $("#delivery-type-submit").text("Reserve Delivery");
    $("#delivery-type-select-btns button").removeClass(
      "delivery-type-select-btns-selected"
    );
    $(this).addClass("delivery-type-select-btns-selected");
    $(".delivery-express-info").css("display", "flex");
    $("#delivery-error-modal").hide();
    $("#delivery-preorder-token, #delivery-preorder-token-input-box").hide();
    $.removeCookie("delivery_preorder", { path: "/" });

    loadDeliverySlots(postcode);
  });

  //Delivery type selection.
  $("#delivery-type-form").submit(function (e) {
    localStorage.setItem("currentPickingStore", $.cookie("picking_store"));
    var clickCollect = $("#delivery-type-click-collect").hasClass(
        "delivery-type-select-btns-selected"
    );
    var postcode = clickCollect
        ? $("#cc-store option:selected").data("zone_postcode")
        : $("#spost-code-modal").val();
    var expressDelivery = $("#delivery-type-express").hasClass(
        "delivery-type-select-btns-selected"
    ); // If on express tab - only show these slots.
    var doCartUpdate = false;

    if (clickCollect) {
        localStorage.setItem("clickCollectSelected", "true");
    } else {
        localStorage.removeItem("clickCollectSelected");
    }

    var deliveryDate = $("#date-picker-select").val();

    // Get the selected delivery slot ID
    var uniqueWindow = $("#sdelivery-time-modal option:selected").attr(
        "data-slot-id"
    );

    // Reserve delivery slot.
    $.ajax({
        type: "GET",
        url: deliveryURL + "reservations.php?c=?",
        data: {
            action: "set",
            cart_id: $.cookie("cart"),
            unique_window: uniqueWindow,
            express_delivery: expressDelivery,
        },
        dataType: "jsonp",
        cache: false,
        success: function (data_reservation) {
            if (data_reservation.status === "SUCCESS") {
                var _data = JSON.parse($.cookie("postcode_data"));
                console.log("----- RESERVATION ------");
                console.log(uniqueWindow);

                 fetch("https://apps.harrisfarm.com.au/delivery/liquor-allowed.php?delivery_unique_window=" +
                    encodeURIComponent(uniqueWindow))
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((liquorData) => {
                        var liquorAllowed = liquorData.liquorAllowed;
                        var currentTime = new Date()
                            .toTimeString()
                            .split(" ")[0]
                            .replace(/:/g, "");
                        var liquorDeliveryStart = liquorData.liquorStartTime;
                        var liquorDeliveryEnd = liquorData.liquorEndTime;
                        localStorage.setItem("liquorDeliveryStart", liquorDeliveryStart);
                        localStorage.setItem("liquorDeliveryEnd", liquorDeliveryEnd);
                        console.log("--------- LIQUOR ----------");
                        console.log(liquorDeliveryStart);
                        console.log(liquorDeliveryEnd);
                        console.log(liquorAllowed);

                        if (
                            liquorAllowed &&
                            currentTime >= liquorDeliveryStart &&
                            currentTime <= liquorDeliveryEnd
                        ) {
                            localStorage.setItem("liquorDeliveryAvailable", "true");
                        } else {
                            localStorage.setItem("liquorDeliveryAvailable", "false");
                        }
                    })
                    .catch((error) => {
                        console.error("Error occurred:", error);
                        localStorage.setItem("liquorDeliveryAvailable", "false");
                    });

                // Continue with the rest of your code
                $.ajax({
                    type: "GET",
                    url: deliveryURL + "postcodedetails.php?a=1&c=?",
                    data: {
                        postcode: postcode,
                        delivery_date: deliveryDate,
                        express_delivery: expressDelivery,
                    },
                    dataType: "jsonp",
                    cache: false,
                    success: function (data) {
                        if (data.status === "SUCCESS") {
                            data.response = data.response[0];
                            if (
                                data.response !== "EMPTY" &&
                                data.response.postcode == postcode
                            ) {
                                //Postcode ok - set postcode, picking_store and delivery details cookies and update toolbar
                                $.cookie("postcode", postcode, { expires: 365, path: "/" });
                                $.cookie("suburb", _data.response.suburb, {
                                    expires: 365,
                                    path: "/",
                                });

                                console.log(
                                    $.cookie("picking_store") +
                                    " " +
                                    data.response.picking_store
                                );
                                if (
                                    $.cookie("picking_store") &&
                                    $.cookie("picking_store") != data.response.picking_store
                                ) {
                                    // Picking store change.
                                    doCartUpdate = true;
                                    console.log("Update cart");
                                }
                                $.cookie("picking_store", data.response.picking_store, {
                                    expires: 365,
                                    path: "/",
                                });
                                $("#delivering-to").show().find("a").html($.cookie("suburb"));

                                //Set delivery details cookies.
                                $.cookie(
                                    "delivery_expires_time",
                                    new Date().getTime() +
                                    data_reservation.response.seconds_remaining * 1000,
                                    { expires: 365, path: "/" }
                                );
                                $.cookie("delivery_date", deliveryDate, {
                                    expires: 365,
                                    path: "/",
                                });
                                $.cookie(
                                    "delivery_type",
                                    $("#sdelivery-type-modal option:selected").val(),
                                    { expires: 365, path: "/" }
                                );
                                if (clickCollect) {
                                    $.cookie("delivery_cc_store", $("#cc-store").val(), {
                                        expires: 365,
                                        path: "/",
                                    }); //Save selected store.
                                    $.cookie(
                                        "delivery_cc_name",
                                        $("#cc-store option:selected").text(),
                                        { expires: 365, path: "/" }
                                    );
                                    $.cookie(
                                        "postcode_cc_display",
                                        $("#spost-code-modal").val(),
                                        { expires: 365, path: "/" }
                                    ); //Used for display postcode they entered - CC doesn't use it.
                                } else {
                                    $.removeCookie("delivery_cc_store", { path: "/" });
                                }
                                $.cookie(
                                    "delivery_type_long",
                                    $("#sdelivery-type-modal option:selected").text(),
                                    { expires: 365, path: "/" }
                                );
                                $.cookie(
                                    "delivery_time",
                                    $("#sdelivery-time-modal option:selected").val(),
                                    { expires: 365, path: "/" }
                                );
                                $.cookie(
                                    "delivery_time_short",
                                    $("#sdelivery-time-modal option:selected").text(),
                                    { expires: 365, path: "/" }
                                );
                                $.cookie("delivery_run", data.response.delivery_run, {
                                    expires: 365,
                                    path: "/",
                                });
                                $.cookie("delivery_courier", data.response.courier, {
                                    expires: 365,
                                    path: "/",
                                });
                                $.cookie("delivery_unique_window", uniqueWindow, {
                                    expires: 365,
                                    path: "/",
                                });
                                $.cookie("delivery_type_changed", 1, {
                                    expires: 365,
                                    path: "/",
                                });

                                //Hide delivery type prompt.
                                theme.hidePromptForDeliveryType();

                                //Remove delivery later cookie.
                                $.removeCookie("delivery_later", { path: "/" });

                                //Get zone distribution centre state for product filtering.
                                $.ajax({
                                    type: "GET",
                                    url: deliveryURL + "get-state-filter.php?c=?",
                                    data: { zone_id: _data.response.zone },
                                    dataType: "jsonp",
                                    cache: false,
                                    success: function (data) {
                                        if (data.status === "SUCCESS") {
                                            //Set current state
                                            $.cookie("curr_state", data.state, {
                                                expires: 365,
                                                path: "/",
                                            });

                                            if (doCartUpdate) {
                                                //Picking store change - update cart items to correct variants.
                                                agileCart.updateCartItems();
                                                console.log("Update cart action");
                                            } else {
                                                //Refresh page - delivery reservation changed.
                                                console.log("No updated needed");
                                                window.location.reload();
                                            }
                                        }
                                    },
                                    error: function (err) {
                                        return false;
                                    },
                                });
                            }
                        }
                    },
                    error: function (err) {
                        return false;
                    },
                    complete: function () {
                        localStorage.setItem("activeDelivery", "true");
                    },
                });
            }
        },
        error: function (err) {
            return false;
        },
    });

    //saveSelectionsToLocalStorage();
    return false;
});

  $(".delivery-edit-btn, .change-delivery-res, .delivery-details-text").click(function () {
    theme.promptForDeliveryType();
    updateDeliveryDrawer();
  });

  // Function to save selections to localStorage
  function saveSelectionsToLocalStorage() {
    var clickCollectSelected = $("#delivery-type-click-collect").hasClass(
      "delivery-type-select-btns-selected"
    );
    var deliveryType = clickCollectSelected ? "clickCollect" : "delivery";
    var postcode;

    // Check if click and collect is selected to get the postcode from the associated store option
    if (clickCollectSelected) {
      postcode = $("#spost-code-modal").val();
      localStorage.setItem("selectedStore", $("#cc-store").val()); // Assuming you're saving the store selection
    } else {
      // For other delivery types, assuming the postcode is entered by the user in an input field
      postcode = $("#spost-code-modal").val();
    }

    var expressDelivery = $("#delivery-type-express").hasClass(
      "delivery-type-select-btns-selected"
    );
    var selectedTimeSlot = $("#sdelivery-time-modal option:selected").val();

    localStorage.setItem("deliveryType", deliveryType);
    localStorage.setItem("postcode", postcode);
    localStorage.setItem("expressDelivery", expressDelivery);
    localStorage.setItem("selectedTimeSlot", selectedTimeSlot);
    // Save other selections as needed...
  }

  // Function to populate the delivery drawer with saved values
  window.updateDeliveryDrawer = function () {
    var postcode = $.cookie("postcode");
    var clickAndCollect = $.cookie("delivery_type") === "M";
    var expressDelivery = $.cookie("delivery_type") === "EX";
    var selectedTimeSlot = $.cookie("delivery_time");
    var selectedStore = $.cookie("picking_store");
    $("#delivery-type-selection-section").show();

    if (clickAndCollect) {
      $("#delivery-type-click-collect").addClass(
        "delivery-type-select-btns-selected"
      );
      // Assuming you have a function or logic to populate or select the correct store
      $("#cc-store").val(selectedStore);
      $("#spost-code-modal").val($.cookie("postcode_cc_display"));
      loadClickCollectStores();
    } else {
      $("#delivery-type-express").addClass(
        "delivery-type-select-btns-selected"
      );
      $("#spost-code-modal").val(postcode);
    }

    if (expressDelivery) {
      $("#cc-store-row").hide();
      $("#delivery-type-express").addClass(
        "delivery-type-select-btns-selected"
      );
      $("#delivery-express-uber").css("display", "flex");
      $("#delivery-express-noliquor-warning").css("display", "flex");
      if (postcode) {
        loadDeliverySlots(postcode);
      }
    }

    $("#sdelivery-time-modal").val(selectedTimeSlot);
  };

  $("#delivery-type-decide-later").click(function () {
    $.cookie("delivery_later", 1, { expires: 365, path: "/" }); // Set delivery later flag.
    if ($.cookie("delivery_expires_time")) {
      $.cookie("delivery_expires_time", 0, { expires: 365, path: "/" }); //Reset delivery expiry time.
      checkDeliveryOptionsExpired(); //Clear delivery reservation.
    }
    //$(".hfmModalClose").click();
    location.reload();
  });

  $(".cancel-delivery-button").click(function () {
    localStorage.removeItem("activeDelivery");
    if ($.cookie("delivery_expires_time")) {
      $.cookie("delivery_expires_time", 0, { expires: 365, path: "/" }); //Reset delivery expiry time.
      checkDeliveryOptionsExpired(); //Clear delivery reservation.
    }
    const deliveryExpired = true;
    //agileCart.fetchCart(deliveryExpired);
    location.reload();
  });

  //Pre-order functionality
  $("#preorder-token").change(function () {
    if ($("#preorder-token").is(":checked")) {
      $("#delivery-preorder-token-input-box").show();
      $("#delivery-preorder-token-input").val("").focus();
    } else {
      $(
        "#delivery-preorder-token-input-box, #delivery-preorder-invalid"
      ).hide();
      $.removeCookie("delivery_preorder", { path: "/" });
    }
    loadDeliverySlots($("#spost-code-modal").val()); //Refresh slots
  });

  $("#delivery-preorder-token-input").on("input", function () {
    $("#delivery-preorder-invalid").remove();

    if ($(this).val().length == 6) {
      //Validate preorder number.
      $.ajax({
        type: "GET",
        url:
          deliveryURL +
          "preorder.php?c=?&token=" +
          $("#delivery-preorder-token-input").val(),
        dataType: "json",
        success: function (response) {
          if (response.token) {
            //Valid.
            $.cookie("delivery_preorder", response.token, {
              expires: 365,
              path: "/",
            });
            $("#delivery-type-delivery").click(); //Reload slots in case already have reservation.
          } else {
            //Invalid.
            $("#delivery-preorder-token-input-box").prepend(
              '<div id="delivery-preorder-invalid">Code not valid. Enter a valid 6 digit preorder code.</div>'
            );
            $.removeCookie("delivery_preorder", { path: "/" });
          }
        },
      });
    }
  });

  //NDIS functionality
  $("#ndis_checkbox").change(function () {
    $("#ndis-modal").toggle();
    if (!$(this).prop("checked")) {
      $.removeCookie("delivery_ndis", { path: "/" });
      $("#ndis").val("");
      theme.promptForDeliveryType(); //Reload slots in case already have reservation.
    } else {
      $("#ndis").val($.cookie("delivery_ndis")).focus();
    }
  });

  $("#ndis").on("input", function () {
    $("#ndis-modal td .error").remove();

    if ($(this).val().length == 12) {
      //Show loader.
      $("#ndis_loader").show();
      $("#ndis").prop("disabled", true);

      //Validate NDIS number.
      $.ajax({
        type: "GET",
        url: deliveryURL + "ndis.php?c=?&token=" + $("#ndis").val(),
        dataType: "json",
        success: function (response) {
          if (response.token) {
            //Valid.
            $.cookie("delivery_ndis", response.token, {
              expires: 365,
              path: "/",
            });
            theme.promptForDeliveryType(); //Reload slots in case already have reservation.
          } else {
            //Invalid.
            $("#ndis-modal td:last-child").append(
              '<div class="error" style="font-size:12px">** Code not valid. Enter a valid 12 digit NDIS priority access code. **</div>'
            );
          }
        },
        complete: function () {
          $("#ndis_loader").hide();
          $("#ndis").prop("disabled", false);
        },
      });
    }
  });
  //End NDIS functionality

  $("#cc-store").change(function () {
    let postcode = $("option:selected", this).data("zone_postcode");

    $(
      "#delivery-postcode-modal, #delivery-suburb-modal, #delivery-day-modal, #delivery-type-modal, #clickcollect-info-modal, #delivery-time-modal"
    ).hide();
    $("#delivery-type-submit").prop("disabled", true);
    if ($(this).val()) {
      loadDeliverySlots(postcode);
    }
  });

  $("#spost-code-modal").on("input", function () {
    //Make sure other dropdowns/msgs are hidden and enter disabled in case re-entering postcode.
    $(
      "#delivery-type-selection-section, #delivery-error-modal, #delivery-type-reserve, #delivery-suburb-modal, #delivery-day-modal, #delivery-type-modal, #delivery-time-modal, #clickcollect-info-modal, .delivery-express-info, #delivery-preorder-token, #delivery-preorder-token-input-box"
    ).hide();
    $("#delivery-type-submit").prop("disabled", true);
    $("#submit-delivery-postode").prop("disabled", true);

    //Process post code entered.
    if ($(this).val().length == 4) {
      $("#submit-delivery-postode").prop("disabled", false);
    }
  });

  $("#submit-delivery-postode").click(function () {
    $("#delivery-type-select-btns button").removeClass(
      "delivery-type-select-btns-selected"
    );
    showAvailableDeliveryButtons();
  });

  $("#sdelivery-type-modal").change(function () {
    if ($(this).val() != "0") {
      selectedType = $(this).val();
      $("#sdelivery-type-modal").val(selectedType);
      updateSlotsForModal();
    } else {
      $("#delivery-time-modal").hide();
    }
    $("#delivery-type-submit").prop("disabled", true);
  });

  $("#sdelivery-time-modal").change(function () {
    if ($(this).val() != "0") {
      $("#sdelivery-type-modal").val(
        $(this).find(":selected").attr("data-del-type")
      );
      $("#delivery-type-submit").prop("disabled", false);
    } else {
      $("#delivery-type-submit").prop("disabled", true);
    }
  });
  // End delivery type selection.

  //Display delivery details in header.
});

function showAvailableDeliveryButtons() {
  let postcode = $("#spost-code-modal").val();

  if (
    ![$.cookie("postcode"), $.cookie("postcode_cc_display")].includes(postcode)
  ) {
    // Checking different postcode to reservation - clear pre selected delivery type
    $("#delivery-type-select-btns button").removeClass();
  }

  // Check if standard delivery is available for postcode.
  $.ajax({
    type: "GET",
    url: deliveryURL + "postcodedetails.php?c=?",
    data: { postcode: postcode, express_delivery: false },
    dataType: "jsonp",
    cache: false,
    success: function (data) {
      if (data.status === "SUCCESS") {
        data.response = data.response[0];
        if (data.response !== "EMPTY" && data.response.postcode == postcode) {
          $("#delivery-type-delivery").show(); // Available.
        } else {
          $("#delivery-type-delivery").hide(); // Not available.
        }
        // Check if express delivery is available for postcode.
        $.ajax({
          type: "GET",
          url: deliveryURL + "postcodedetails.php?c=?",
          data: { postcode: postcode, express_delivery: true },
          dataType: "jsonp",
          cache: false,
          success: function (data) {
            if (data.status === "SUCCESS") {
              data.response = data.response[0];
              if (
                data.response !== "EMPTY" &&
                data.response.postcode == postcode
              ) {
                $("#delivery-type-express").show(); // Available.
              } else {
                $("#delivery-type-express").hide(); // Not available.
              }

              $("#delivery-type-selection-section").show();
            }
          },
        });
      }
    },
  });
}

function loadClickCollectStores() {
  $("#delivery-type-submit").prop("disabled", true);

  $.ajax({
    type: "POST",
    url: deliveryURL + "clickandcollect-stores.php?c=?",
    dataType: "jsonp",
    success: function (response) {
      $("#cc-store option").slice(1).remove();
      response.stores.forEach(function (store) {
        $("#cc-store").append(
          "<option value='" +
            store.store_no +
            "' data-zone_postcode='" +
            store.zone_postcode +
            "' data-picking_store='" +
            store.picking_store +
            "'>" +
            store.name +
            "</option>"
        );
      });
      if ($.cookie("delivery_cc_store")) {
        $("#cc-store").val($.cookie("delivery_cc_store")).change(); //Previously selected.
      }
    },
    error: function (err) {
      console.log(err);
    },
  });
}

function loadDeliverySlots(postcode) {
  var expressDelivery = $("#delivery-type-express").hasClass(
    "delivery-type-select-btns-selected"
  ); // If on express tab - only show these slots.
  console.log(postcode);
  console.log(expressDelivery);
  //Show loader.
  $(
    "#delivery-type-submit, #delivery-type, #ndis_checkbox, #ndis, #spost-code-modal, #cc-store, #delivery-type-select-btns button"
  ).prop("disabled", true);
  $("#delivery-day-modal, #delivery-time-modal").hide();
  $("#delivery-suburb-modal").remove();

  $.ajax({
    type: "GET",
    url: deliveryURL + "postcodedetails.php?a=1&c=?",
    data: { postcode: postcode, express_delivery: expressDelivery },
    dataType: "jsonp",
    cache: false,
    success: function (data) {
      console.log(data);

      if (data.status === "SUCCESS") {
        // Show delivery selection.
        $("#delivery-type-selection-section").show();
        $("#delivery-type-reserve").show();

        // Hide reservation expired message.
        if (!$("#delivery-error-modal").hasClass("reservation-expired")) {
          $("#delivery-error-modal").hide();
        }

        // Set postcode and picking store if not set.
        if (
          data.response[0] !== "EMPTY" &&
          data.response[0].postcode == postcode
        ) {
          if (!$.cookie("postcode") && !$.cookie("picking_store")) {
            // Postcode ok - set postcode
            $.cookie("postcode", postcode, { expires: 365, path: "/" });
            // Set picking store
            $.cookie("picking_store", data.response[0].picking_store, {
              expires: 365,
              path: "/",
            });
          }
        }

        if (data.response == "EMPTY") {
          // No Postcode Match - show error.
          errorMsg = expressDelivery ? noExpressDeliveryError : noDeliveryError;
          $("#delivery-error-modal").removeClass().html(errorMsg);
          $("#delivery-error-modal").css("display", "flex");

          $(
            "#delivery-type, #ndis_checkbox, #ndis, #spost-code-modal, #cc-store, #delivery-type-select-btns button"
          ).prop("disabled", false);
        } else if (!data.response[0].suburb) {
          // Show slots available with no suburbs set for postcode.
          data.response = !data.response[0].id
            ? data.response
            : data.response[0];
          return to_select_slot(data, postcode);
        } else {
          // Show slots available with suburbs set for postcode.
          return to_select_suburb(data, postcode);
        }
      }
    },
  });
}

function to_select_suburb(data, postcode) {
  $(
    "#delivery-type, #ndis_checkbox, #ndis, #spost-code-modal, #cc-store, #delivery-type-select-btns button"
  ).prop("disabled", false);
  var options = '<option value="">Select Suburb</option>';
  var s_suburb = $.cookie("suburb");
  var selected = false;

  for (var k in data.response) {
    var e = data.response[k];
    if (e.suburb == s_suburb) {
      selected = true;
      var sl = " selected ";
    } else {
      var sl = "";
    }
    options +=
      "<option " +
      sl +
      ' value="' +
      e.id +
      ":" +
      e.postcode +
      ":" +
      e.suburb +
      ":" +
      e.picking_store +
      ":" +
      postcode +
      ":" +
      e.zone +
      '">' +
      e.suburb +
      "</option>";
  }
  options =
    '<div class="delivery-select"><select id="select-suburb-dropdown" >' +
    options +
    "</select></div>";
  var con =
    '<tr id="delivery-suburb-modal"><td><strong>Suburb</strong></td><td>' +
    options +
    "</td></tr>";
  $("#delivery-suburb-modal").remove();
  $(con).insertBefore($("#delivery-day-modal"));
  if (selected) {
    const selectedValue = $("#select-suburb-dropdown").val();
    _to_select_slot(selectedValue);
  }
}

function _to_select_slot(selectedValue) {
  console.log(selectedValue);
  var v = selectedValue;

  if (!v) {
    $("#delivery-day-modal, #delivery-time-modal").hide();
    $("#delivery-type-submit").prop("disabled", true);
    return;
  }
  var d = v.split(":"); //Array [ "1947", "2000", "MILLERS POINT", "73", "2000" ]
  var data = {
    response: {
      id: d[0],
      postcode: d[1],
      suburb: d[2],
      picking_store: d[3],
      zone: d[5],
    },
  };

  $("#delivery-type-submit").prop("disabled", true);
  $("#delivery-time-modal").hide();
  to_select_slot(data, d[4]);
}

function to_select_slot(data, postcode) {
  var expressDelivery = $("#delivery-type-express").hasClass(
    "delivery-type-select-btns-selected"
  ); // If on express tab - only show these slots.
  var postcodeType = expressDelivery ? "Express" : "Normal";

  if (data.response.postcode == postcode) {
    $.cookie("postcode_data", JSON.stringify(data), {
      expires: 365,
      path: "/",
    });

    $.ajax({
      dataType: "jsonp",
      url:
        deliveryURL +
        "get-dates.php?cart_id=" +
        $.cookie("cart") +
        "&postcode=" +
        postcode +
        "&suburb=" +
        encodeURIComponent(data.response.suburb || "") +
        "&postcode_type=" +
        postcodeType +
        "&store_number=" +
        data.response.picking_store +
        ($.cookie("delivery_ndis") ? "&ndis=1" : "") +
        ($.cookie("delivery_preorder") ? "&preorder=1" : "") +
        "&callback=?",
      success: function (data) {
        slots_modal = data;
        displaySlotsForModal(slots_modal);
        if ($.cookie("delivery_expires_time")) {
          //Show selected delivery options if reservation already set.
          $("#date-picker-select").val($.cookie("delivery_date")).change();
          $("#sdelivery-type-modal").val($.cookie("delivery_type")).change(); //Call change to populate delivery times.
          $("#sdelivery-time-modal").val($.cookie("delivery_time")).change();
        }
        $("#delivery-day-modal").css("display", "flex");
      },
      complete: function () {
        $(
          "#delivery-type, #ndis_checkbox, #ndis, #spost-code-modal, #cc-store, #delivery-type-select-btns button"
        ).prop("disabled", false);
      },
    });
  }
}

document.addEventListener("change", function (event) {
  if (event.target && event.target.id === "select-suburb-dropdown") {
    const selectedValue = event.target.value;
    console.log(selectedValue);
    _to_select_slot(selectedValue);
  }
});

const selectElement = document.getElementById("select-suburb-dropdown");
if (selectElement) {
  const currentValue = selectElement.value;
  _to_select_slot(currentValue);
}

function displaySlotsForModal(slots_modal) {
  availableDatesForModal = []; //Clear array before adding dates.
  $("#date-picker-select").empty().prop("disabled", false);

  if (slots_modal.dates != null) {
    //Add dates to array.
    availableDatesForModal = $.map(slots_modal.dates, function (value, index) {
      return [value];
    });
    //Sort dates in array.
    availableDatesForModal.sort(function (a, b) {
      let date1 = a.split("-").join(""),
        date2 = b.split("-").join("");
      return date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
    });
    //Add dates to select.
    $("#date-picker-select").append(new Option("Select delivery date"));
    $.each(availableDatesForModal, function (i, delDate) {
      let [year, month, day] = delDate.split("-");
      $("#date-picker-select").append(
        new Option(
          new Date(year, month - 1, day).toLocaleDateString("en-AU", {
            weekday: "long",
            day: "numeric",
            month: "long",
          }),
          delDate
        )
      );
    });
    $("#date-picker-select").change(function () {
      selectedDate = $(this).val();
      if (selectedDate != "Select delivery date") {        
        updateTypesForModal(selectedDate);
        updateSlotsForModal(selectedDate);
        $("#delivery-day-modal, #delivery-time-modal").css("display", "flex");
        $("#delivery-type-submit").prop("disabled", true);
      } else {
        $("#delivery-time-modal").hide();
        $("#delivery-type-submit").prop("disabled", true);
      }
    });
  } else {
    $("#date-picker-select")
      .append(new Option("No dates available"))
      .prop("disabled", true);
  }
}

function updateTypesForModal(selectedDate) {
  var optionHtml = "";

  if (slots_modal["slots"][selectedDate] == undefined) {
    alert(
      "There are no delivery slots available on the date you selected. Please select an alternative date."
    );
    return false;
  }

  $("#sdelivery-type-modal").empty();
  optionHtml = '<option value="0">Select delivery type</option>';

  $.each(slots_modal["slots"][selectedDate], function (i, el) {
    optionHtml += '<option value="' + i + '">' + el.description + "</option>";
  });

  $("#sdelivery-type-modal").html(optionHtml);
}

function updateSlotsForModal() {
  $("#sdelivery-time-modal").empty();
  var optionHtml = '<option value="0">Select delivery time</option>';
  $.each(slots_modal["slots"][selectedDate], function (x, v) {
    selectedType = x;
    $.each(v["time"], function (i, el) {
      optionHtml +=
        '<option value="' +
        el.value +
        '" data-del-type="' +
        selectedType +
        '" data-slot-id="' +
        el.id +
        '" data-expiry=' +
        el.e +
        ">" +
        el.description +
        " (" +
        v.description.substring(
          0,
          v.description.indexOf("(") == -1
            ? v.description.length
            : v.description.indexOf("(") - 1
        ) +
        ")</option>";
    });
  });
  $("#sdelivery-time-modal").append(optionHtml);
  var opt = $("#sdelivery-time-modal option[value!=0]").sort(function (a, b) {
    a = $(a)
      .attr("data-slot-id")
      .substring(
        $(a).attr("data-slot-id").split("-", 4).join("-").length + 1,
        $(a).attr("data-slot-id").length
      );
    b = $(b)
      .attr("data-slot-id")
      .substring(
        $(b).attr("data-slot-id").split("-", 4).join("-").length + 1,
        $(b).attr("data-slot-id").length
      );
    return a < b ? -1 : a > b ? 1 : 0;
  });
  $("#sdelivery-time-modal").append(opt);
  $("#delivery-time-modal").show();
}

//Update header with the currently selected delivery details.
function updateDeliveryDetailsHeader() {
  var weekday = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  var deliveryDate = new Date($.cookie("delivery_date"));
  var deliveryDetailsHTML,
    deliveryDay,
    deliveryTimeShort = $.cookie("delivery_time_short");
  let pickingStore = getCookie("picking_store");

  if ($.cookie("delivery_expires_time") != null) {
    //Check if delivery reservation expired.
    if (checkDeliveryOptionsExpired()) {
      theme.promptForDeliveryType();
      return; //Exit
    }

    //Update delivery details box.
    deliveryTimeShort = deliveryTimeShort
      .substring(0, deliveryTimeShort.indexOf("("))
      .trim()
      .replace(/:00 /g, "")
      .toLowerCase();

    console.log(deliveryTimeShort);

    deliveryDay = weekday[deliveryDate.getDay()].substring(0, 3);

    if (pickingStore) {
      const storeId = parseInt(pickingStore, 10);
      storeName = storeMatrix[0][storeId] || storeName;
    }

    //deliveryTimer =
    deliveryDetailsHTML = `<a href="#">
         <div class="delivery-flex-organiser">
          <div class="delivery-store">
            <label class="delivery-to-label">Picking store</label>
            <span class="">${storeName}</span>
          </div>
          <div class="delivery-divider first-divider"></div>
           <div class="delivery-to">
              <label class="delivery-to-label">Delivering to</label>
              <span class="postcode-text"></span>
           </div>
           <div class="delivery-divider"></div>
           <div class="delivery-date-time">
              <div class="minutes-remaining hide-minutes">${getDeliveryMinutesRemaining()}</div>
              <label class="">Delivery slot</label>
              <span class="delivery_date">${deliveryDay} ${deliveryTimeShort}</span>
           </div>
           <div class="delivery-edit-btn">
             <svg class="icon-edit" enable-background="new 0 0 100 100" height="512" viewBox="0 0 100 100" width="512" xmlns="http://www.w3.org/2000/svg"><g><path d="m18 84.2c1 0 1.2-.1 2.1-.3l18-3.6c1.9-.5 3.8-1.4 5.3-2.9l43.6-43.6c6.7-6.7 6.7-18.2 0-24.9l-3.7-3.9c-6.7-6.7-18.3-6.7-25 0l-43.6 43.7c-1.4 1.4-2.4 3.4-2.9 5.3l-3.8 18.2c-.5 3.4.5 6.7 2.9 9.1 1.9 1.9 4.7 2.9 7.1 2.9zm3.4-28.3 43.6-43.7c2.9-2.9 8.2-2.9 11 0l3.8 3.8c3.4 3.4 3.4 8.2 0 11.5l-43.5 43.7-18.5 3.1z"/><path d="m86.6 90.4h-73.8c-2.9 0-4.8 1.9-4.8 4.8s2.4 4.8 4.8 4.8h73.4c2.9 0 5.3-1.9 5.3-4.8-.1-2.9-2.5-4.8-4.9-4.8z"/></g></svg>
           </div>
         </div>
      </a>`;

    $(".header__delivery--dialog").addClass("delivery_active");
    $(".delivery-details-text").html(deliveryDetailsHTML);

    //Update minutes.
    //$(".minutes_remaining").html(timeConvert(getDeliveryMinutesRemaining()));

    //Show delivery details box.
    showDeliveryDetailsBox();

    // Function to convert minutes into a countdown format (hh:mm)
    function convertToCountdown(minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return `${String(hours).padStart(2, "0")}:${String(mins).padStart(
        2,
        "0"
      )}`;
    }

    // Function to update the countdown every minute until it reaches zero
    function startCountdown() {
      let remainingMinutes = getDeliveryMinutesRemaining();

      function updateCountdown() {
        if (remainingMinutes > 0) {
          const countdown = convertToCountdown(remainingMinutes);
          console.log(countdown); // Display the countdown (you can update it in your UI)
          if (document.body.classList.contains("template-cart")) {
            cartTimer.innerHTML = countdown + " left";
            cartTimer.style.display = "block";
          }
          remainingMinutes--;
          //setTimeout(updateCountdown, 60000); // Call this function again after 1 minute (60,000 ms)
        } else {
          console.log("Countdown reached zero!"); // Or update your UI to indicate the countdown has reached zero
          //Clear delivery cookies.
          clearDeliveryCookies();

          //Clear reservation end timer;
          clearInterval(resEndIntHandle);
          //Hide delivery details box.
          hideDeliveryDetailsBox();
        }
      }

      // Initial call to start the countdown
      //updateCountdown();
    }

    //startCountdown();

    //Bind to resize event.
    $(window).resize(function () {
      if ($.cookie("delivery_expires_time")) {
        showDeliveryDetailsBox();
      }
    });

    //Update delivery link.
    if ($.cookie("delivery_type") == "M") {
      $(".delivery-to-label").html("Click & collect");
      $(".postcode-text").html(
        $.cookie("delivery_cc_name")
          .replace("Junction", "")
          .replace("(", "")
          .replace(")", "")
      );
    } else {
      $(".postcode-text").html($.cookie("suburb"));
    }

    //Update reservation expiry timer every 30 seconds.
    resEndIntHandle = setInterval(function () {
      if (checkDeliveryOptionsExpired()) {
        theme.promptForDeliveryType();
      }
    }, 30000);
  }
}

updateDeliveryDetailsHeader();

//Check if delivery options have expired, if so clear cookies and make expire msg visible on postcode/delivery popup.
function checkDeliveryOptionsExpired() {
  if (getDeliveryMinutesRemaining() <= 0) {
    const deliveryExpired = true;
    agileCart.fetchCart(deliveryExpired);
    //Clear delivery cookies.
    clearDeliveryCookies();

    //Clear reservation end timer;
    clearInterval(resEndIntHandle);
    if (document.body.classList.contains("template-cart")) {
      document.querySelector(".delivery-updating").textContent =
        "Please reserve a delivery slot or pickup store.";
    }
    //Hide delivery details box.
    hideDeliveryDetailsBox();
    //Show expired delivery options message on popup.
    errorMsg = `<span class="delivery-error-message"><span><b>Delivery reservation expired</b></span> <span>Please select again below.</span>`;
    $("#delivery-error-modal").addClass("reservation-expired");
    $("#delivery-error-modal").html(errorMsg);
    $("#delivery-error-modal").css("display", "flex");

    //If on cart page - show expired message in place of delivery details.
    if ($("body").hasClass("template-cart")) {
      $("#reserve_delivery_msg").show();
      $("#delivery_cart_table").hide();
      //$("checkout").hide();
    }
    return true;
  }
  return false;
}

// Get number of minutes remaining for delivery reservation.
function getDeliveryMinutesRemaining() {
  var currTime = new Date().getTime(),
    minutesRemaining;
  minutesRemaining =
    $.cookie("delivery_expires_time") != null
      ? parseInt(($.cookie("delivery_expires_time") - currTime) / 60000)
      : 0;
  return minutesRemaining;
}

// Function to update the minutes remaining
function updateMinutesRemaining() {
  var minutesRemaining = getDeliveryMinutesRemaining();
  var minutesRemainingElement = document.querySelector(".minutes-remaining");

  if (minutesRemainingElement) {
    if (minutesRemaining > 0) {
      minutesRemainingElement.innerHTML = `<svg enable-background="new 0 0 371.263 371.263" height="512" viewBox="0 0 371.263 371.263" width="512" xmlns="http://www.w3.org/2000/svg"><g><g><path d="m305.402 234.794v-70.54c0-52.396-33.533-98.085-79.702-115.151.539-2.695.838-5.449.838-8.204.001-22.575-18.323-40.899-40.898-40.899s-40.899 18.324-40.899 40.899c0 2.695.299 5.389.778 7.964-15.868 5.629-30.539 14.551-43.054 26.647-23.593 22.755-36.587 53.354-36.587 86.169v73.115c0 2.575-2.096 4.731-4.731 4.731-22.096 0-40.959 16.647-42.995 37.845-1.138 11.797 2.755 23.533 10.719 32.276 7.904 8.683 19.222 13.713 31.018 13.713h72.217c2.994 26.887 25.869 47.905 53.534 47.905s50.54-21.018 53.534-47.905h72.217c11.797 0 23.114-5.03 31.018-13.713 7.904-8.743 11.797-20.479 10.719-32.276-2.036-21.198-20.958-37.845-42.995-37.845-2.635-.001-4.731-2.097-4.731-4.731zm-119.762-210.842c9.341 0 16.946 7.605 16.946 16.946 0 .778-.12 1.497-.24 2.275-4.072-.599-8.204-1.018-12.336-1.138-7.126-.24-14.132.24-21.078 1.198-.12-.778-.24-1.497-.24-2.275.002-9.401 7.607-17.006 16.948-17.006zm0 323.358c-14.431 0-26.527-10.3-29.342-23.952h58.683c-2.813 13.653-14.909 23.952-29.341 23.952zm143.655-67.665c.479 5.15-1.138 10.12-4.551 13.892-3.533 3.773-8.204 5.868-13.353 5.868h-251.501c-5.15 0-9.82-2.096-13.294-5.868-3.473-3.772-5.09-8.743-4.611-13.892.838-9.042 9.282-16.168 19.162-16.168 15.809 0 28.683-12.874 28.683-28.683v-73.115c0-26.228 10.419-50.719 29.282-68.923 18.024-17.425 41.498-26.887 66.528-26.887 1.198 0 2.335 0 3.533.06 50.839 1.796 92.277 45.929 92.277 98.325v70.54c0 15.809 12.874 28.683 28.683 28.683 9.88 0 18.264 7.126 19.162 16.168z"/></g></g></svg> ${minutesRemaining}mins remaining`;
      if (minutesRemaining < 15) {
        minutesRemainingElement.classList.remove("hide-minutes");
      }
    } else {
      minutesRemainingElement.textContent = "Time is up!";
      clearInterval(countdownInterval); // Stop the interval when time is up
    }
  }
}

var countdownInterval = setInterval(updateMinutesRemaining, 60000);
// Initial call to set the countdown immediately on page load
updateMinutesRemaining();

//Show either mobile or non mobile delivery details box.
function showDeliveryDetailsBox() {
  $("#delivery-details-box").show();
  $(".delivery-wrapper").hide();
  $(".delivery-details").show();
}

//Hide delivery details box.
function hideDeliveryDetailsBox() {
  document.querySelector(
    ".delivery-details-text"
  ).innerHTML = `<svg class="icon icon-location" version="1.1" id="svg192" xml:space="preserve" width="682.66669" height="682.66669" viewBox="0 0 682.66669 682.66669" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><defs id="defs196"><clipPath clipPathUnits="userSpaceOnUse" id="clipPath206"><path d="M 0,512 H 512 V 0 H 0 Z" id="path204"></path></clipPath></defs><g id="g198" transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g id="g200"><g id="g202" clip-path="url(#clipPath206)"><g id="g208" transform="translate(324.9316,350.6797)"><path d="m 0,0 c 0,-38.07 -30.861,-68.932 -68.932,-68.932 -38.07,0 -68.931,30.862 -68.931,68.932 0,38.07 30.861,68.932 68.931,68.932 C -30.861,68.932 0,38.07 0,0 Z" style="fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path210"></path></g><g id="g212" transform="translate(371.8301,440.165)"><path d="m 0,0 c -27.55,35.6 -70.81,56.87 -115.83,56.87 -45.02,0 -88.28,-21.27 -115.83,-56.87 -31.07,-40.16 -36.63,-88.55 -20.3,-135.84 15.7,-45.46 49.04,-83.37 76.3,-122.44 19.5,-27.95 39,-55.9 58.5,-83.86 0.44,-0.63 0.89,-1.27 1.33,-1.9 0.44,0.63 0.89,1.27 1.33,1.9 19.5,27.96 39,55.91 58.5,83.86 27.26,39.07 60.6,76.98 76.3,122.44 C 36.63,-88.55 31.07,-40.16 0,0 Z" style="fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path214"></path></g><g id="g216" transform="translate(164.25,126.8052)"><path d="m 0,0 -42.65,-26.94 134.4,-84.9 134.4,84.9 L 183.5,0" style="fill:none;stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" id="path218"></path></g></g></g></g></svg> Set my location`;
  $("#delivery-details-box").hide();
  $("#mobile-delivery-details").hide();
  $(".delivery-details").hide();
  $(".delivery-wrapper").show();
}

function clearDeliveryCookies() {
  $.each($.cookie(), function (name) {
    if (
      /^delivery_/.test(name) &&
      ![
        "delivery_type",
        "delivery_ndis",
        "delivery_cc_store",
        "delivery_later",
      ].includes(name)
    ) {
      $.removeCookie(name, { path: "/" });
    }
  });
}
